"use strict";

define('language/support/supplemental.moment.locales',['require','exports','module'],function (require, exports, module) {
  module.exports = {
    'en-sg': {
      months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      longDateFormat: {
        LT: 'h:mm a',
        LTS: 'h:mm:ss a',
        L: 'D/M/YYYY',
        LL: 'D MMM YYYY',
        LLL: 'D MMMM YYYY LT',
        LLLL: 'dddd, D MMMM YYYY LT'
      },
      calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
      },
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
      },
      ordinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      },
      week: {
        dow: 1,
        doy: 4
      }
    },
    'zh-sg': {
      months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
      weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
      longDateFormat: {
        LT: 'Ah點mm',
        LTS: 'Ah點m分s秒',
        L: 'YYYY年MMMD日',
        LL: 'YYYY年MMMD日',
        LLL: 'YYYY年MMMD日LT',
        LLLL: 'YYYY年MMMD日ddddLT',
        l: 'YYYY年MMMD日',
        ll: 'YYYY年MMMD日',
        lll: 'YYYY年MMMD日LT',
        llll: 'YYYY年MMMD日ddddLT'
      },
      meridiemParse: /早上|上午|中午|下午|晚上/,
      meridiemHour: function meridiemHour(hour, meridiem) {
        if (hour === 12) {
          hour = 0;
        }
        if (meridiem === '早上' || meridiem === '上午') {
          return hour;
        } else if (meridiem === '中午') {
          return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
          return hour + 12;
        }
      },
      meridiem: function meridiem(hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 900) {
          return '早上';
        } else if (hm < 1130) {
          return '上午';
        } else if (hm < 1230) {
          return '中午';
        } else if (hm < 1800) {
          return '下午';
        } else {
          return '晚上';
        }
      },
      calendar: {
        sameDay: '[今天]LT',
        nextDay: '[明天]LT',
        nextWeek: '[下]ddddLT',
        lastDay: '[昨天]LT',
        lastWeek: '[上]ddddLT',
        sameElse: 'L'
      },
      ordinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function ordinal(number, period) {
        switch (period) {
          case 'd':
          case 'D':
          case 'DDD':
            return number + '日';
          case 'M':
            return number + '月';
          case 'w':
          case 'W':
            return number + '週';
          default:
            return number;
        }
      },
      relativeTime: {
        future: '%s內',
        past: '%s前',
        s: '幾秒',
        m: '一分鐘',
        mm: '%d分鐘',
        h: '一小時',
        hh: '%d小時',
        d: '一天',
        dd: '%d天',
        M: '一個月',
        MM: '%d個月',
        y: '一年',
        yy: '%d年'
      }
    }
  };
});

